<template>
  <v-snackbar
      v-model="visible"
      :timeout="timeout"
      :color="color"
      top
      right
  >
    {{ message }}
  </v-snackbar>

</template>

<script>
import {EventBus} from "@/plugins/eventBus";

export default {
  name: "AlertComponent",
  data() {
    return {
      visible: false,
      message: "",
      color: "info",
      timeout: 3000,
    };
  },
  methods: {
    showSnackbar({ message, color = "info", timeout = 3000 }) {
      this.message = message;
      this.color = color;
      this.timeout = timeout;
      this.visible = true;
    },
  },
  created() {
    EventBus.$on("showSnackbar", this.showSnackbar);
  },
  beforeDestroy() {
    EventBus.$off("showSnackbar", this.showSnackbar);
  },
}
</script>

<style scoped>

</style>
